import { render, staticRenderFns } from "./EditRoomType.modal.vue?vue&type=template&id=5b6de7c6&scoped=true&"
import script from "./EditRoomType.modal.vue?vue&type=script&lang=js&"
export * from "./EditRoomType.modal.vue?vue&type=script&lang=js&"
import style0 from "./EditRoomType.modal.vue?vue&type=style&index=0&id=5b6de7c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6de7c6",
  null
  
)

export default component.exports